import { render, staticRenderFns } from "./PlaceItem.vue?vue&type=template&id=d7133984&"
import script from "./PlaceItem.vue?vue&type=script&lang=ts&"
export * from "./PlaceItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports